<template>
    <b-modal :title="this.$route.name" no-close-on-backdrop hide-footer size="lg" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="updateInvoice">
            <div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label ">নাগরিক</label>
                    <div class="col-sm-4">
                        <input type="text" readonly name="customer" v-model="editInvoice.customer" class="form-control"  >
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label ">হিসাব নাম্বার</label>
                    <div class="col-sm-4">
                        <div class="input-group">
                            <input type="text" readonly name="account_no" v-model="editInvoice.account_no" class="form-control"  >
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label">বকেয়া</label>
                    <div class="col-sm-4">
                        <input name="due_amount" readonly type="number" v-model="editInvoice.due_amount" class="form-control">
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label">মাসিক বিল</label>
                    <div class="col-sm-4">
                        <input name="amount" readonly type="number" v-model="editInvoice.amount" class="form-control">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label">সার চার্জ</label>
                    <div class="col-sm-4">
                        <input name="due_charge" data-vv-as="'Shar Charge'" v-validate="'required'" type="number" v-model="editInvoice.due_charge" @change="changeDueCharge()" class="form-control">
                        <p v-show="errors.has('due_charge')" style="color:red">* This field is required</p>
                    </div>
                    <label for="inputPassword3" class="col-sm-2 col-form-label">মোট বিল</label>
                    <div class="col-sm-4">
                        <input type="number" data-vv-as="'Mot Bill'" v-validate="'required'" name="total" v-model="editInvoice.total" class="form-control">
                        <p v-show="errors.has('total')"  style="color:red">* This field is required</p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">সিক্রেট পিন<span class="required">*</span></label>
                    <div class="col-sm-4">
                        <input type="password" data-vv-as="'Secret Pin'" v-validate="'required'" name="secret_pin" v-model="editInvoice.secret_pin" placeholder="Enter Secret Pin" class="form-control">
                        <p v-show="errors.has('secret_pin')"  style="color:red">* This field is required</p>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-12">
                <input v-if="!addLoader" type="submit" value="Submit" class="btn btn-primary pull-right"/>
                <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
                <button v-if="!addLoader"  @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)
import axios from 'axios'
import {ALL_PURPOSE,ALL_ACCOUNT_TYPE2,ALL_CONTACT,ADD_INVOICE} from "../../../store/action.type"
import { mapState,mapGetters } from "vuex"
import { VueEditor } from 'vue2-editor'
export default {
    props:['invoice_type'],
    data(){
        return{
            largeModal:false,
            addLoader:false,
            editInvoice:{
                customer:'',
                account_no:'',
                total:'',
                amount:'',
                due_charge:'',
                due_amount:'',
                invoice_type:'',
                date:'',
                end_date:'',
                last_date:'',
                account_id:'',
                customer_id:'',
                connection_fee:'',
                secret_pin:'',
                Pre_DueCharge:'',
                Pre_Total:'',
                Pre_DueAmount:''
            },
        }
    },

    methods:{
        openModal(invoice){
            //console.log(invoice)
            this.editInvoice.pin = invoice.secret_pin
            this.largeModal = true
            this.editInvoice.id = invoice.id
            this.editInvoice.customer = invoice.customer
            this.editInvoice.account_no = invoice.account_no
            this.editInvoice.total = invoice.total
            this.editInvoice.Pre_Total = invoice.total
            this.editInvoice.amount = invoice.amount
            this.editInvoice.due_charge = invoice.due_charge
            this.editInvoice.Pre_DueCharge = invoice.due_charge
            this.editInvoice.due_amount = invoice.due_amount
            this.editInvoice.Pre_DueAmount = invoice.due_amount
            this.editInvoice.invoice_type = invoice.invoice_type
            this.editInvoice.date = invoice.date
            this.editInvoice.end_date = invoice.end_date
            this.editInvoice.last_date = invoice.last_date
            this.editInvoice.account_id = invoice.account_id
            this.editInvoice.customer_id = invoice.customer_id
            this.editInvoice.personal_note = invoice.personal_note
            this.editInvoice.connection_fee = invoice.connection_fee
            this.editInvoice.secret_pin = ''

        },
        changeDueCharge(){
            if(this.editInvoice.Pre_DueCharge==this.editInvoice.due_charge){
                this.editInvoice.total = parseInt(this.editInvoice.Pre_Total)
            }else{
                this.editInvoice.total = (parseInt(this.editInvoice.Pre_Total)-parseInt(this.editInvoice.Pre_DueCharge))+parseInt(this.editInvoice.due_charge)
            }
        },
        updateInvoice(){
            this.editInvoice.invoice_type = this.invoice_type;
            this.$validator.validateAll().then( result =>{
                if(result){
                    var data = this.editInvoice
                    //console.log(data)
                    this.addLoader = true
                    //this.$store.dispatch('UPDATE_INVOICE',data)
                    if(data.secret_pin==data.pin){
                        this.$store.dispatch('UPDATE_INVOICE',data)
                        .then(response=>{
                            this.addLoader = false;
                            this.largeModal = false
                            this.$iziToast.success({position:'topRight',title:'Ok',message:"Invoice Updated Successsfully"})
                        })
                        .catch(error=>{
                            this.addLoader = false;
                            this.$iziToast.error({position:'topRight',title:'Error',message:"Something Wrong !!"})
                        });
                    }else{
                        this.addLoader = false;
                        this.$iziToast.error({position:'topRight',title:'Error',message:"Secret pin is wrong"})
                    }
                }

            })

        },
        close(){
            this.largeModal = false
        },
    },
    mounted(){
    },
    computed:{


    },
    components:{
    }
}
</script>

<style>
#preview {
        height: 120px;
        width: 70%;
    }
    #preview img{
        height: 100%;
        width: 100%;
    }
</style>
